import { render, staticRenderFns } from "./page5.vue?vue&type=template&id=a0072456&scoped=true&"
import script from "./page5.vue?vue&type=script&lang=js&"
export * from "./page5.vue?vue&type=script&lang=js&"
import style0 from "./page5.vue?vue&type=style&index=0&id=a0072456&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0072456",
  null
  
)

export default component.exports